<template>
    <router-link
        :to="blockLink"
        class="tool-block"
    >
        <InlineSvg :src="require(`../../assets/svgs/${svg}.svg`)" class="tool-block__svg"/>
        <p v-html="text" class="body-copy body-copy--align-center"></p>
    </router-link>
</template>

<script>
    import InlineSvg from 'vue-inline-svg';

    export default {
        name: 'ToolBlock',
        props: {
            svg: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: true
            },
            buttonText: {
                type: String,
                default: ''
            },
            from: {
                type: String,
                default: ''
            },
            blockLink: {
                type: String,
                default: '',
            },
            flexRow: {
                type: Boolean,
                default: false
            }
        },
        components: {
            InlineSvg,
        },
    }
</script>

